import { useHref } from "react-router-dom";
import { PositionedSpinner } from "../../../../../../components/ui/PositionedSpinner";
import { ComputedDatum, SunburstChart, useTheme } from "../../../../../../components/widgets/sunburst/sunburst";
import I18n from "../../../../../../core/localization/I18n";
import { getBasenameAsPrefix } from "../../../../../../core/util/Helpers";
import { ElementTypes } from "../../../../../../enums";
import { ProgrammeDashboardSunburstLegend } from "./ProgrammeDashboardSunburstLegend";
import { getSunburstDrillThroughUrl } from "./redirectToGrid";

const ProgrammeDashboardTooltip = ({ data }: ComputedDatum<any>) => {
  const theme = useTheme();
  let labelText = "";

  if (data.elementType === ElementTypes.PROJECT) {
    labelText = `${I18n.t("entities.project")}: ${data.label}`;
  } else if (data.id === -1) {
    labelText = data.label;
  } else if (data.elementType === ElementTypes.PROGRAMME) {
    labelText = `${I18n.t("entities.programme")}: ${data.label}`;
  } else if (data.elementType === ElementTypes.IMPACT || data.elementType === ElementTypes.ACTION) {
    let value = getChildrenSum(data.children);
    labelText = `${data.label}: ${value}`;
  } else {
    labelText = `${data.label}: ${data.value}`;
  }

  return <strong style={{ ...theme.tooltip.container }}>{labelText}</strong>;
};

const getChildrenSum = children => {
  return children.reduce((prev, curr) => prev + curr.value, 0);
};

export const ProgrammeDashboardSunburstCard = ({ sunburst, organisationId }) => {
  const basename = useHref("/");
  const redirectToGridFn = datum => {
    if (!datum.data.children.length) {
      const url = getSunburstDrillThroughUrl(datum, organisationId);
      window.location.href = getBasenameAsPrefix(basename) + url;
      return false;
    }
    return true;
  };

  return (
    <div className="col d-flex">
      <ProgrammeDashboardSunburstLegend hasMoreThanOneProjects={sunburst?.children?.length > 1} />
      {!sunburst && <PositionedSpinner />}
      {sunburst && (
        <SunburstChart
          className="sunburst-dashboard"
          data={sunburst}
          tooltipFn={ProgrammeDashboardTooltip}
          onClickFn={redirectToGridFn}
        />
      )}
    </div>
  );
};
